import React, { useEffect } from "react";
import ModalDownload from "../../layout/Modal/ModalDownload";
import TitlePages from "../../layout/TitlePages";
import { distLocal, intDist, infoRel } from "../../data/dataMapas";
import Breadcrumbs from "../../layout/Breadcrumbs";
import "./Mapas.css";

const MapItem = ({ link, title, modalId }) => (
  <div>
    <div className="hover-ite">
      <a
        href="/#"
        rel="noreferrer"
        data-bs-toggle="modal"
        data-bs-target={`#${modalId}`}
      >
        <img src={link} className="img-fluid w-100 mx-auto" alt={title} />
      </a>
    </div>
    <div className="Mapas__dist-footer bg-ite">{title}</div>

    <ModalDownload
      idModal={modalId}
      linkIMG={link}
      altIMG={title}
      downloadModal={link}
    />
  </div>
);

const Mapas = () => {
  useEffect(() => {
    document.title = `Mapas`;
  }, []);

  return (
    <>
      <Breadcrumbs path={[{ label: "Distritación Poder Judicial 2025" }]} />

      <TitlePages
        title="Demarcaciones"
        subTitle="Distritación Poder Judicial Tlaxcala 2025"
      />

      <div className="d-flex align-items-start w-100 margin-bottom-2">
        {/* NAV */}
        <div
          className="nav flex-column nav-pills me-3 w-10"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          <button
            className="btn btn-ite active"
            id="v-pills-mapaTLX1-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-mapaTLX1"
            type="button"
            role="tab"
            aria-controls="v-pills-mapaTLX1"
            aria-selected="true"
          >
            COBERTURA JUDICIAL LOCAL PENAL
          </button>

          <button
            className="btn btn-ite"
            id="v-pills-mapaTLX2-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-mapaTLX2"
            type="button"
            role="tab"
            aria-controls="v-pills-mapaTLX2"
            aria-selected="false"
          >
            COBERTURA JUDICIAL LOCAL CFM
          </button>

          <a
            href="https://pelepj-2025.itetlax.org.mx/?route=geografia-electoral"
            className="btn btn-ite"
            target="_blank"
            rel="noopener noreferrer"
          >
            INFOGRAFÍAS
          </a>

        </div>

        {/* CONTENT */}
        <div className="tab-content w-90" id="v-pills-tabContent">
          {/* TAB 1 */}
          <div
            className="tab-pane fade show active"
            id="v-pills-mapaTLX1"
            role="tabpanel"
            aria-labelledby="v-pills-mapaTLX1-tab"
          >
            <MapItem
              link="https://itetlax.org.mx/assets/img/imgDemA/PJ1.png"
              title="COBERTURA JUDICIAL LOCAL PENAL"
              modalId="modalMapaTLX1"
            />
          </div>

          {/* TAB 2 */}
          <div
            className="tab-pane fade"
            id="v-pills-mapaTLX2"
            role="tabpanel"
            aria-labelledby="v-pills-mapaTLX2-tab"
          >
            <MapItem
              link="https://itetlax.org.mx/assets/img/imgDemA/PJ2.png"
              title="COBERTURA JUDICIAL LOCAL CIVIL FAMILIAR Y MERCANTIL"
              modalId="modalMapaTLX2"
            />
          </div>

          {/* DISTRITOS LOCALES */}
          <div
            className="tab-pane fade"
            id="v-pills-mapaXDistLoc"
            role="tabpanel"
          >
            <div className="Grid__three">
              {distLocal.map((dLocal) => (
                <MapItem
                  key={dLocal.id}
                  link={dLocal.link}
                  title={`Distrito ${dLocal.id}`}
                  modalId={`modalDLocal${dLocal.id}`}
                />
              ))}
            </div>
          </div>

          {/* INTEGRACIÓN DISTRITAL */}
          <div
            className="tab-pane fade"
            id="v-pills-intDist"
            role="tabpanel"
          >
            <div className="Grid__three">
              {intDist.map((item) => (
                <MapItem
                  key={item.id}
                  link={item.link}
                  title={item.title}
                  modalId={`modalIntDist${item.id}`}
                />
              ))}
            </div>
          </div>

          {/* INFORMACIÓN RELACIONADA */}
          <div
            className="tab-pane fade"
            id="v-pills-infoRel"
            role="tabpanel"
          >
            <div className="Grid__three">
              {infoRel.map((mapa) => (
                <MapItem
                  key={mapa.id}
                  link={mapa.link}
                  title={mapa.title}
                  modalId={`modalInfoRel${mapa.id}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Mapas;
